var exports = {
  "k": "x04b3a21e--d78a81--container",
};

module.exports = exports;
